import clsx, { type ClassValue } from 'clsx';

/**
 * Tiny className combiner in the shadcn/ui spirit. We deliberately avoid
 * `tailwind-merge` to keep the dependency surface minimal for the MVP;
 * conflicting utility classes are simply not passed together by callers.
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
